
interface SyncStatusProps {
  date: string
}

export const SyncStatus = ({ date }: SyncStatusProps) => {
  const syncedAt = new Date(date)
  const now = new Date()
  const diffHours = Math.abs(now.getTime() - syncedAt.getTime()) / 36e5
  
  const isOnline = diffHours < 4 // Assumed online if synced within last 4 hours

  return (
    <div className="flex items-center gap-1.5" title={`Last synced: ${syncedAt.toLocaleString()}`}>
      <span className={`relative flex h-2 w-2`}>
        {isOnline && <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>}
        <span className={`relative inline-flex rounded-full h-2 w-2 ${isOnline ? 'bg-emerald-500' : 'bg-slate-300 dark:bg-slate-600'}`}></span>
      </span>
      <span className="text-xs text-muted-foreground">
        {isOnline ? 'Online' : 'Offline'}
      </span>
    </div>
  )
}
